import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function InnerSection(props) {
  return null;
}
export const Section = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerSection, { ...props,
  forwardedRef: ref
}));